import axios from "@/libs/axios";

export const getFinanceReviewProjects = async (params?: any) => {
  return axios.get("project/finance-review/projects", { params });
};

export const updateFinanceNote = async (id: number, note: string) => {
  return axios.patch(`/project/finance-review/note/${id}`, { note });
};
